import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function ProductCard() {
  const revealRef = useScrollReveal();
  return <section id="producto" className="relative bg-brand-cream py-[60px] md:py-[100px] px-[5%] overflow-hidden" data-id="element-168">
      <div ref={revealRef} className="max-w-[900px] mx-auto relative z-10 reveal" data-id="element-169">
        <div className="text-center mb-[56px]" data-id="element-170">
          <div className="text-brand-gold text-[11px] uppercase tracking-[0.15em] mb-4" data-id="element-171">
            TU INVERSIÓN
          </div>
          <h2 className="font-display italic text-[clamp(36px,5vw,48px)] text-brand-ink leading-tight" data-id="element-172">
            Invierte en tu transformación
          </h2>
        </div>

        <div className="bg-brand-dark border border-brand-gold/40 rounded-[24px] overflow-hidden relative shadow-[0_20px_60px_rgba(0,0,0,0.3)] transition-transform duration-500 hover:-translate-y-2" data-id="element-173">
          <div className="absolute top-0 left-0 w-full h-[4px] bg-gradient-to-r from-brand-violet via-brand-gold to-brand-cream" data-id="element-174" />

          <div className="flex flex-col md:flex-row" data-id="element-175">
            {/* Left Column - Image */}
            <div className="md:w-[40%] bg-brand-dark/50 p-[48px_40px] flex items-center justify-center relative border-b md:border-b-0 md:border-r border-white/5" data-id="element-176">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(123,92,232,0.15)_0%,_transparent_70%)] blur-[60px] -z-10" data-id="element-177" />

              <img src="https://cdn.magicpatterns.com/uploads/okFEir8M4AQMPTjnkjVmQW/RENACER.png" alt="RENACER: El Protocolo Cuántico" className="w-[280px] rounded-[8px] shadow-[0_20px_40px_rgba(0,0,0,0.5)] object-cover transition-transform duration-500 hover:scale-105" data-id="element-178" />
            </div>

            {/* Right Column - Details */}
            <div className="md:w-[60%] p-[40px] md:p-[48px_40px]" data-id="element-179">
              <div className="inline-flex items-center bg-[#DC3232]/15 border border-[#DC3232]/30 text-[#FF6B6B] text-[12px] py-[5px] px-[14px] rounded-[40px] mb-5" data-id="element-180">
                ⚡ Precio de lanzamiento — tiempo limitado
              </div>

              <h3 className="font-display text-[32px] font-medium text-brand-cream mb-1 leading-tight" data-id="element-181">
                RENACER: El Protocolo Cuántico
              </h3>
              <p className="font-body text-[14px] text-brand-cream/60 mb-6" data-id="element-182">
                Edición Maestro + 3 Bonos Incluidos
              </p>

              <div className="w-full h-[1px] bg-white/[0.08] my-6" data-id="element-183" />

              <div className="flex flex-col gap-3 mb-8" data-id="element-184">
                {['Protocolo completo en PDF — 100+ páginas', 'Técnicas, meditaciones y checklists', 'BONO: Mapa del Trauma Invisible (valor $19)', 'BONO: Guía Express del Punto Cero (valor $24)', 'BONO: Checklist de la Nueva Identidad (valor $17)', 'Acceso de por vida'].map((item, i) => <div key={i} className="flex items-start gap-[10px] font-body text-[14px] text-brand-cream/80 py-[4px]" data-id="element-185">
                    <span className="text-brand-gold mt-[2px]" data-id="element-186">✦</span>
                    {item}
                  </div>)}
              </div>

              <div className="w-full h-[1px] bg-white/[0.08] my-6" data-id="element-187" />

              <div className="mb-6" data-id="element-188">
                <div className="font-body text-[14px] text-brand-cream/40 line-through mb-1" data-id="element-189">
                  Valor total: $107.00
                </div>
                <div className="flex items-baseline gap-4" data-id="element-190">
                  <span className="font-display text-[56px] font-medium text-brand-gold leading-none" data-id="element-191">
                    $13.97
                  </span>
                  <span className="font-body text-[13px] text-brand-gold/80 border border-brand-gold/30 rounded-full px-3 py-1" data-id="element-192">
                    Ahorras más del 85%
                  </span>
                </div>
              </div>

              <a href="https://learniacademy.com/cart/53230890647917:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="block w-full text-center bg-brand-gold text-brand-dark font-body text-[16px] font-medium tracking-[0.03em] py-[20px] rounded-[50px] transition-all duration-300 hover:bg-brand-goldBright hover:-translate-y-[2px] hover:shadow-[0_12px_30px_rgba(201,169,110,0.35)] mb-5" data-id="element-193">
                SÍ, QUIERO RENACER &rarr;
              </a>

              <div className="flex flex-col items-center gap-3" data-id="element-194">
                <div className="flex items-center gap-2" data-id="element-195">
                  <span data-id="element-196">🛡️</span>
                  <span className="font-body text-[13px] text-brand-cream/60 text-center" data-id="element-197">
                    Garantía 7 días — Si no te transforma, te devolvemos el
                    dinero
                  </span>
                </div>
                <div className="font-body text-[12px] text-brand-cream/40" data-id="element-198">
                  Pago 100% seguro
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}